import { render } from "./Questionnaire.vue?vue&type=template&id=32ff452e&scoped=true"
import script from "./Questionnaire.vue?vue&type=script&lang=js"
export * from "./Questionnaire.vue?vue&type=script&lang=js"

import "./Questionnaire.vue?vue&type=style&index=0&id=32ff452e&scoped=true&lang=css"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ff452e"]])

export default __exports__